export const regionDetection = (
    region: string = '',
    approvedRegions: string[] = []
): boolean => {
    if (region) {
        return approvedRegions.includes(region);
    }
    return false;
};
